export default __webpack_public_path__ + "static/media/31.f42d583b.png";